import { Language } from '^/types';

export default {
  signin: {
    [Language.KO_KR]: 'SAML SSO로 계속하기',
    [Language.EN_US]: 'Continue with SAML SSO',
  },
  teamSlug: {
    [Language.KO_KR]: '조직 슬러그',
    [Language.EN_US]: 'Organization Slug',
  },
  tooltip: {
    [Language.KO_KR]: '조직 슬러그는 관리자에게 문의해 주세요.',
    [Language.EN_US]: 'Please contact an administrator for your organization slug.',
  },
  errorMessage: {
    [Language.KO_KR]: '제출하시기 전에 조직 슬러그를 입력해 주세요.',
    [Language.EN_US]: 'Please enter your organization slug before submitting.',
  },
  notFoundErrorMessage: {
    [Language.KO_KR]: '이 조직에는 SAML SSO가 설정되지 않았습니다. 관리자에게 문의해 주세요.',
    [Language.EN_US]:
      'SAML SSO has not been configured for this organization. Kindly contact with the administrator.',
  },
  unauthorizedErrorMessage: {
    [Language.KO_KR]: '이 작업을 수행할 권한이 없습니다. 유효한 자격 증명으로 로그인해주세요.',
    [Language.EN_US]:
      'You are not authorized to perform this action. Please sign in with valid credentials.',
  },
  unprocessableErrorMessage: {
    [Language.KO_KR]: '요청을 처리할 수 없습니다. 사용 방법을 확인하고 다시 시도해주세요.',
    [Language.EN_US]: 'Unable to process your request. Please check your input and try again.',
  },
  defaultErrorMessage: {
    [Language.KO_KR]: '오류가 발생했습니다. 나중에 다시 시도해주세요.',
    [Language.EN_US]: 'There may be an error in the server. Please try again later.',
  },
};
